import React from "react";
import { styled } from "@mui/material/styles";

// ── Styled SVG wrappers ───────────────────────────────────────────────────────
const IcoSvg = styled("svg")({
  display: "inline-block",
  flexShrink: 0,
});

const UsersSvg = styled("svg")({
  display: "inline-block",
  flexShrink: 0,
});

// ── Ico — base SVG wrapper ────────────────────────────────────────────────────
export const Ico = ({ size = 20, stroke = 1.67, style, children }) => (
  <IcoSvg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    {children}
  </IcoSvg>
);

// ── Icons map ─────────────────────────────────────────────────────────────────
export const Icons = {
  search: (p) => (
    <Ico {...p}>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </Ico>
  ),
  x: (p) => (
    <Ico {...p}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Ico>
  ),
  chevDown: (p) => (
    <Ico {...p}>
      <path d="m6 9 6 6 6-6" />
    </Ico>
  ),
  chevRight: (p) => (
    <Ico {...p}>
      <path d="m9 6 6 6-6 6" />
    </Ico>
  ),
  check: (p) => (
    <Ico {...p}>
      <path d="M20 6 9 17l-5-5" />
    </Ico>
  ),
  star: (p) => (
    <Ico {...p} stroke="0" style={{ fill: "#FEC84B", ...p?.style }}>
      <polygon points="12,2 15,9 22,9.5 17,14.5 18.5,21.5 12,17.8 5.5,21.5 7,14.5 2,9.5 9,9" />
    </Ico>
  ),
  starOut: (p) => (
    <Ico {...p}>
      <polygon points="12,2 15,9 22,9.5 17,14.5 18.5,21.5 12,17.8 5.5,21.5 7,14.5 2,9.5 9,9" />
    </Ico>
  ),
  clock: (p) => (
    <Ico {...p}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </Ico>
  ),
  book: (p) => (
    <Ico {...p}>
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </Ico>
  ),
  zap: (p) => (
    <Ico {...p}>
      <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
    </Ico>
  ),
  filter: (p) => (
    <Ico {...p}>
      <path d="M22 3H2l8 9.46V19l4 2v-8.54z" />
    </Ico>
  ),
  sparkle: (p) => (
    <Ico {...p}>
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
    </Ico>
  ),
  flame: (p) => (
    <Ico {...p}>
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
    </Ico>
  ),
  arrowRight: (p) => (
    <Ico {...p}>
      <path d="M5 12h14m-6-6 6 6-6 6" />
    </Ico>
  ),
  arrowLeft: (p) => (
    <Ico {...p}>
      <path d="M19 12H5m6 6-6-6 6-6" />
    </Ico>
  ),
  share: (p) => (
    <Ico {...p}>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </Ico>
  ),
  bookmark: (p) => (
    <Ico {...p}>
      <path d="m19 21-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </Ico>
  ),
  play: (p) => (
    <Ico {...p} stroke="0" style={{ fill: "currentColor", ...p?.style }}>
      <polygon points="6,4 20,12 6,20" />
    </Ico>
  ),
  volume: (p) => (
    <Ico {...p}>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
    </Ico>
  ),
  volumeOff: (p) => (
    <Ico {...p}>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <line x1="23" y1="9" x2="17" y2="15" />
      <line x1="17" y1="9" x2="23" y2="15" />
    </Ico>
  ),
  mic: (p) => (
    <Ico {...p}>
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M19 10a7 7 0 0 1-14 0" />
      <line x1="12" y1="19" x2="12" y2="22" />
    </Ico>
  ),
  phone: (p) => (
    <Ico {...p}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21.27 16z" />
    </Ico>
  ),
  award: (p) => (
    <Ico {...p}>
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
    </Ico>
  ),
  user: (p) => (
    <Ico {...p}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Ico>
  ),
  lock: (p) => (
    <Ico {...p}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </Ico>
  ),
  topic: (p) => (
    <Ico {...p}>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none" />
    </Ico>
  ),
  users: ({ size = 16, style } = {}) => (
    <UsersSvg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.6666 14V12.6667C14.6666 11.4241 13.8167 10.38 12.6666 10.084M10.3333 2.19384C11.3105 2.58943 11.9999 3.54754 11.9999 4.66667C11.9999 5.78579 11.3105 6.7439 10.3333 7.13949M11.3333 14C11.3333 12.7575 11.3333 12.1362 11.1303 11.6462C10.8596 10.9928 10.3405 10.4736 9.68707 10.203C9.19702 10 8.57576 10 7.33325 10H5.33325C4.09074 10 3.46949 10 2.97943 10.203C2.32602 10.4736 1.80689 10.9928 1.53624 11.6462C1.33325 12.1362 1.33325 12.7575 1.33325 14M8.99992 4.66667C8.99992 6.13943 7.80601 7.33333 6.33325 7.33333C4.86049 7.33333 3.66659 6.13943 3.66659 4.66667C3.66659 3.19391 4.86049 2 6.33325 2C7.80601 2 8.99992 3.19391 8.99992 4.66667Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </UsersSvg>
  ),
};
